import ColorfulIndexbar from './colorful-indexbar';
export default ColorfulIndexbar;
